var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-start") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-start"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 0c-5.5111 0-10.002 4.5378-10.002 10.111 0 4.0617 2.4223 7.8664 4.7586 10.702 2.3364 2.8352 4.6727 4.7254 4.6727 4.7254l0.57035 0.46211 0.57035-0.46211s2.3364-1.8902 4.6727-4.7254c2.3364-2.8352 4.7552-6.6399 4.7552-10.702 0-5.5732-4.4872-10.111-9.9983-10.111",
    fill: "#7ED321"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m16.188 9.6381c0-1.2874-0.0013-2.5735 0.0013-3.8609 0-0.2471-0.01375-0.49667 0.01875-0.73883 0.05751-0.42748 0.26254-0.74624 0.75135-0.75242 0.48131-0.00618 0.71134 0.28416 0.7801 0.72153 0.02501 0.16185 0.02501 0.32741 0.02501 0.49173 0.0012 1.9336 0.0038 3.8671 0 5.8007-0.0013 0.49791 0.0175 1.0428-0.57508 1.2454-0.62383 0.21251-1.0876-0.08648-1.4289-0.59674-0.92768-1.3899-1.8516-2.7823-2.7779-4.1735-0.11252-0.16926-0.22878-0.33606-0.41506-0.60786-0.02501 0.27552-0.05251 0.44354-0.05251 0.61157-0.0025 1.1515 0 2.303 0 3.4557 0 0.14455 0.0062 0.28787-0.0038 0.43119-0.04001 0.6264-0.3388 0.96616-0.84261 0.93033-0.59133-0.04324-0.74885-0.4596-0.75135-0.95133-0.01-1.9126-5e-3 -3.8251-0.0062-5.7389 0-0.18532 0.0025-0.37065 0.0075-0.55474 0.01251-0.50285 0.22128-0.88585 0.72885-1.0292 0.51257-0.14455 0.88137 0.091427 1.1602 0.51026 1.0726 1.6136 2.149 3.2259 3.2242 4.8394 0.05376-0.01235 0.10501-0.023475 0.15627-0.03336z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m5.5731 12.6c-2.5053-0.00247-4.038-1.5901-4.0293-4.1735 0.00875-2.5637 1.5265-4.1402 3.9918-4.1476 2.5003-0.0074132 4.0268 1.5802 4.0155 4.176-0.011252 2.5797-1.5152 4.1463-3.978 4.1451zm2.3128-4.0104c-0.093762-0.54609-0.12502-1.002-0.25503-1.4282-0.29879-0.98099-1.0701-1.5234-2.0878-1.532-0.98138-0.00865-1.7402 0.5115-2.054 1.4814-0.32629 1.0094-0.32504 2.025 0.15627 2.9961 0.3838 0.77589 1.0426 1.1527 1.909 1.1465 0.86136-0.0062 1.5502-0.36818 1.9003-1.1564 0.22003-0.49543 0.30504-1.0502 0.43131-1.5073z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOn);
export default __webpack_public_path__ + "static/media/pin-on.bfa7772c772a58dba3b7eafd83c2aac4.svg";
export { ForwardRef as ReactComponent };